// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Swi1","tabsBox":"styles_tabsBox__18TiN","createButton":"styles_createButton__3PBDP"};